// TODO - remove becouse of legacy

import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'store/createRootReducer'
import * as actions from '../../actions'
import * as selectors from '../../selectors'

const mapStateToProps = (state: ReduxState) => ({
  adSpendsRows: selectors.listRowsSelector(state),
  dateList: selectors.dateListSelector(state),
  isLoading: selectors.isLoadingSelectorByKey(state, 'isLoadingSave')
})

const mapDispatchToProps = {
  saveAdSpends: actions.saveAdSpends,
  changeDate: actions.changeDateList
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector>
